import type { InteractionTraceEvent } from "@/components/shared/interaction-trace/interaction-trace";

export const AUDIT_EVENT_TYPE_VALUES = [
  "DECISION",
  "ACCESS",
  "EVIDENCE_VERIFIED",
  "EXPORT",
  "SECURITY",
] as const;
export type AuditEventType = (typeof AUDIT_EVENT_TYPE_VALUES)[number];

export const AUDIT_INTEGRITY_VALUES = ["verified", "pending", "failed"] as const;
export type AuditIntegrityState = (typeof AUDIT_INTEGRITY_VALUES)[number];

export const AUDIT_PHI_LEVEL_VALUES = ["none", "masked", "restricted"] as const;
export type AuditPhiLevel = (typeof AUDIT_PHI_LEVEL_VALUES)[number];

export const AUDIT_TIME_RANGE_VALUES = ["24h", "7d", "30d", "all"] as const;
export type AuditTimeRange = (typeof AUDIT_TIME_RANGE_VALUES)[number];

export type AuditOutcome = "allowed" | "blocked" | "completed" | "failed";

export interface AuditIntegrityProof {
  state: AuditIntegrityState;
  proofType: string;
  payloadHash: string;
  leafHash: string;
  rootHash: string;
  verifiedAt: string;
}

export interface AuditEventItem {
  id: string;
  sequence: number;
  eventType: AuditEventType;
  eventName: string;
  summary: string;
  actorName: string;
  actorId: string;
  actorRole: string;
  resourceType: string;
  resourceLabel: string;
  resourceId: string;
  action: string;
  policyVersion: string;
  modelVersion?: string;
  environment: string;
  occurredAt: string;
  outcome: AuditOutcome;
  integrityState: AuditIntegrityState;
  phiLevel: AuditPhiLevel;
  dataClasses: readonly string[];
  redactionPlan: string;
  accessReason: string;
  requestId: string;
  correlationId: string;
  traceId: string;
  integrity: AuditIntegrityProof;
  traceEvents: readonly InteractionTraceEvent[];
}

export interface AuditExplorerFilters {
  q?: string;
  eventType?: AuditEventType;
  actor?: string;
  resourceType?: string;
  action?: string;
  policyVersion?: string;
  modelVersion?: string;
  integrity?: AuditIntegrityState;
  phiLevel?: AuditPhiLevel;
  environment?: string;
  timeRange?: AuditTimeRange;
}

export interface AuditExplorerListState extends AuditExplorerFilters {
  page: number;
  limit: number;
}

export const DEFAULT_AUDIT_EXPLORER_LIST_STATE: AuditExplorerListState = {
  page: 1,
  limit: 20,
};

export function hasActiveAuditFilters(filters: AuditExplorerFilters): boolean {
  return Boolean(
    filters.q ||
    filters.eventType ||
    filters.actor ||
    filters.resourceType ||
    filters.action ||
    filters.policyVersion ||
    filters.modelVersion ||
    filters.integrity ||
    filters.phiLevel ||
    filters.environment ||
    filters.timeRange,
  );
}

export const AUDIT_TABLE_COLUMN_COUNT = 9;
